var _style, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D40077;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.9,32.8C92.1,33,51,74.1,50.8,124.8c0,10.2,1.6,20.3,4.9,29.9c2.4,6.6,9.5,10.1,16.2,8.1 c6.5-2.5,9.9-9.5,7.8-16.1c-2.7-7.5-3.9-15.5-3.6-23.5c1.1-36.7,31.7-65.5,68.4-64.4c36.7,1.1,65.5,31.7,64.4,68.4 c-1,34.3-28.1,62.2-62.4,64.3c0,0-12.9,0.8-19.4,1.6c-2.4,0.3-4.7,0.8-7,1.4c-0.3,0.3-0.9,0.3-1.2,0l0,0c-0.2-0.3-0.2-0.7,0-1 l2-10.9l12.1-54.6c1.5-6.8-2.9-13.5-9.7-15c-6.8-1.5-13.5,2.9-15,9.7c0,0-28.9,133.6-28.9,134.8c-1.7,6.5,2.3,13.1,8.8,14.7 c0.1,0,0.1,0,0.2,0h0.7c6.5,1.7,13.1-2.2,14.8-8.7c0-0.1,0.1-0.2,0.1-0.3c0-0.2,0-0.4,0-0.6c0.4-1.6,4-19.4,4-19.4 c2.8-13.4,13.6-23.7,27.1-25.8c2.8-0.4,14.5-1.2,14.5-1.2c50.6-5,87.5-50.1,82.4-100.7C227.4,69.5,189.2,34,142.9,32.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.5,245c-8.3-1.7-16.4,3.6-18.1,11.9c0,0.1,0,0.2,0,0.2c-1.8,8.2,3.4,16.4,11.7,18.2c0,0,0,0,0,0h0.4 c8.1,2,16.2-3,18.1-11.1c0-0.1,0-0.1,0-0.2v-0.8C162,254.9,156.7,246.9,148.5,245z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/DOT.b0d1f1e03b6b11e6252e4a6566b8bc36.svg";
export { ForwardRef as ReactComponent };